import React from "react"
import SocialIcon from "../social-icon"
import OldIconButtonBase from "./old-icon-button-base"
import type { OldIconButtonBaseProps } from "./old-icon-button-base"

type OldSocialIconButtonProps = {
  /** Social icon name (e.g. "linkedin-in", "x-twitter") */
  icon: string
} & Omit<OldIconButtonBaseProps, "children">

const OldSocialIconButton = React.forwardRef<
  HTMLButtonElement | HTMLAnchorElement,
  OldSocialIconButtonProps
>(({ icon, ...props }, ref) => {
  return (
    <OldIconButtonBase {...props} ref={ref}>
      <SocialIcon name={icon} className="pointer-events-none" />
    </OldIconButtonBase>
  )
})

export { OldSocialIconButton, OldSocialIconButton as SocialIconButton }
export default OldSocialIconButton
